import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Auth Pages
import Login from './pages/auth/Login';
import Signup from './pages/auth/Signup';
import AdminDashboard from './pages/admin/Dashboard';
import MemberDashboard from './pages/member/Dashboard';

// Protected Route
const ProtectedRoute = ({ children, allowedRoles }) => {
  const { member, loading } = useAuth();

  if (loading) return (
    <div style={styles.loading}>
      <div style={styles.spinner}></div>
      <p>Loading...</p>
    </div>
  );

  if (!member) return <Navigate to="/login" />;

  if (allowedRoles && !allowedRoles.includes(member.role)) {
    return <Navigate to="/login" />;
  }

  return children;
};

// App Routes
const AppRoutes = () => {
  const { member } = useAuth();

  return (
    <Routes>
      {/* Default redirect */}
      <Route path="/" element={
        member
          ? member.role === 'admin'
            ? <Navigate to="/admin/dashboard" />
            : <Navigate to="/member/dashboard" />
          : <Navigate to="/login" />
      } />

      {/* Auth Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />

      {/* Admin Routes - coming soon */}
      <Route path="/admin/dashboard" element={
        <ProtectedRoute allowedRoles={['admin']}>
          <AdminDashboard />
        </ProtectedRoute>
      } />

      {/* Member Routes - coming soon */}
            <Route path="/member/dashboard" element={
        <ProtectedRoute allowedRoles={['admin', 'president', 'vice_president', 'secretary', 'costume_custodian', 'instrument_custodian', 'treasurer', 'member']}>
          <MemberDashboard />
        </ProtectedRoute>
      } />

      {/* 404 */}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastContainer position="top-right" autoClose={3000} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
};

const styles = {
  loading: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#f5f5f5',
  },
  spinner: {
    width: '40px',
    height: '40px',
    border: '4px solid #ddd',
    borderTop: '4px solid #0f3460',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  comingSoon: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
    color: 'white',
    textAlign: 'center',
  },
};

export default App;